import { Lightbulb, Compass, Crown } from 'lucide-react';
import { PILLARS } from '@/lib/brand';
import Reveal from '@/components/Reveal';

const ICONS = { lightbulb: Lightbulb, compass: Compass, crown: Crown };

export default function SignatureDifference() {
  return (
    <section
      id="difference"
      data-testid="signature-difference-section"
      className="relative bg-[#070B12] py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[1px] bg-gradient-to-r from-transparent via-[#B68A35]/50 to-transparent" />
      <div
        className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full opacity-25 pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(182,138,53,0.35) 0%, transparent 70%)' }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-20 md:mb-24">
          <Reveal>
            <div className="overline text-[#D6B36A] mb-6 justify-center inline-flex">The Signature Difference</div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-6">
              Not Another <span className="italic text-white/50">Product Sales Agency</span>.<br />
              A <span className="gold-text">Legacy Advisory</span>.
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <p className="text-white/55 text-base md:text-lg font-light leading-[1.75]">
              Three principles quietly shape everything we do — from your first conversation
              to your family's long-term legacy plan.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16">
          {PILLARS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <Reveal key={p.title} delay={i * 140}>
                <div
                  data-testid={`pillar-card-${i}`}
                  className="text-center relative group"
                >
                  <div className="mx-auto w-20 h-20 rounded-full border border-[#B68A35]/40 flex items-center justify-center mb-8 bg-gradient-to-br from-[#0E2238] to-[#070B12] group-hover:border-[#D6B36A] transition-all duration-500 group-hover:shadow-[0_0_50px_-5px_rgba(214,179,106,0.4)]">
                    <Icon className="w-8 h-8 text-[#D6B36A]" strokeWidth={1.2} />
                  </div>
                  <h3 className="font-serif text-white text-2xl md:text-3xl mb-4 tracking-tight leading-tight">
                    {p.title}
                  </h3>
                  <p className="text-white/55 text-[0.95rem] leading-[1.75] font-light max-w-sm mx-auto">
                    {p.copy}
                  </p>
                  <div className="mt-8 text-[#B68A35]/40 text-xs tracking-[0.4em] font-medium">
                    {['I', 'II', 'III'][i]}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
